import ReactPannellum from 'react-pannellum'
import { useGame } from '../../../../contexts/GameContext'
import { useEffect, useMemo, useState } from 'react'
import { refreshDraggableMarkersToMap } from '../Marker/PanoramaDraggableMarkerHelper'
import { MapOptions } from '../../types'

export const PANORAMA_DEFAULTS = {
  autoLoad: true,
  autoRotate: 0,
  showFullscreenCtrl: false,
}

type PanoramaBoardProps = {
  boardName: string
  boardUrl: string
  mapOptions?: MapOptions
  activeBoardIndex?: number
}

export const PanoramaBoard: React.FC<PanoramaBoardProps> = ({ boardUrl, mapOptions, activeBoardIndex = 0 }) => {
  const { tasks, gameData, moveTask } = useGame()
  const [mapReady, setMapReady] = useState(false)

  useEffect(() => {
    setMapReady(false)
  }, [boardUrl])

  const handleMapReady = () => {
    setMapReady(true)
  }

  const filteredTasks = useMemo(() => {
    return tasks.filter((t) =>
    !(
      t.mapIndex !== activeBoardIndex ||
      t.advanced.isFlash ||
      (gameData?.advancedSettings.levelsEnabled && t.level === 0)
    ))
  }, [tasks, gameData?.advancedSettings.levelsEnabled, activeBoardIndex])

  useEffect(() => {
    if (mapReady) {
      setTimeout(() => {
        refreshDraggableMarkersToMap(
          filteredTasks,
          moveTask,
        )
        const mainElement = document.getElementsByClassName('pnlm-container')[0] as any
        mainElement.ondrop = (e: any) => {
          e.preventDefault()
        }
        mainElement.ondragover = (e: any) => {
          e.preventDefault()
        }
      }, 50)
    }
  }, [filteredTasks, moveTask, mapReady])

  return (
    <div>
      <ReactPannellum
        id={'map_' + boardUrl}
        style={{ width: '100vw', height: 'calc(100vh - 5.25rem - 48px)', background: '#ffffff' }}
        sceneId='seppoScene'
        imageSource={'https://seppo-proxy.herokuapp.com/' + boardUrl}
        config={{
          ...PANORAMA_DEFAULTS,
          yaw: mapOptions ? mapOptions.center[0] : 0,
          pitch: mapOptions ? mapOptions?.center[1] : 0,
          zoom: mapOptions ? mapOptions?.zoom : 100,
        }}
        onPanoramaLoaded={handleMapReady}
      />
    </div>
  )
}
